import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";

import ColumnExerciseInformationAvatar from "../molecules/ColumnExerciseInformationAvatar";
import ColumnText from "../molecules/ColumnText";
import { InputCheck } from "../atoms/InputCheck";

type ExerciseProps = {
  id: string | number;
  name: string;
  image: string;
  series: string;
  repetitions_time: string;
  intensity: string;
  break_seconds: string;
  super_serie: boolean;
};

export type TableListExercisesWeekDescriptionProps = {
  exercises: ExerciseProps[];
  title: string;
  isLoading: boolean;
  rir?: boolean;
  onClickViewExercise: () => void;
  duration?: number | string;
};

const TableListExercisesWeekDescription: React.FC<
  TableListExercisesWeekDescriptionProps
> = ({ title, exercises, isLoading, rir, onClickViewExercise, duration }) => {
  return (
    <div className="px-4">
      {/*DEBAJO DE ACA */}
      <div className="flex justify-between items-center mt-6">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          {title}
        </h1>
        <div className="">
          <label
            htmlFor="price"
            className="block text-sm font-medium leading-6 text-gray-900 text-left"
          >
            {t("forms.label.duration")}
          </label>
          <p className="text-left text-base">
            {duration} <span className="text-gray-500 text-base">min</span>
          </p>
        </div>
      </div>
      {/* Divider debajo del texto */}
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
            {exercises.length === 0 ? (
              <Empty texto={t("maintenance.views.no_task")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      ></th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.series")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.repetitions_time")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.intensity")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.break_seconds")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.super_serie")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {exercises.map((exercise) => (
                      <tr key={exercise.id}>
                        <button onClick={onClickViewExercise}>
                          <ColumnExerciseInformationAvatar
                            name={exercise.name}
                            image={exercise.image}
                          />
                        </button>
                        <ColumnText title={exercise.series} />
                        <td
                          className={
                            "whitespace-nowrap px-3 py-5 text-sm text-gray-500"
                          }
                        >
                          {exercise.repetitions_time}{" "}
                          <span className="text-gray-400">seg</span>
                        </td>
                        <td
                          className={
                            "whitespace-nowrap px-3 py-5 text-sm text-gray-500"
                          }
                        >
                          {exercise.intensity}{" "}
                          <span className="text-gray-400">%</span>
                        </td>
                        <td
                          className={
                            "whitespace-nowrap px-3 py-5 text-sm text-gray-500"
                          }
                        >
                          {exercise.break_seconds}{" "}
                          <span className="text-gray-400">seg</span>
                        </td>
                        <td
                          className={
                            "whitespace-nowrap px-3 py-5 text-sm text-gray-500"
                          }
                        >
                          <InputCheck disabled checked={exercise.super_serie} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListExercisesWeekDescription;
